<template>
    <div class="form-row">
        <p class="text--s">
            <template v-if="enGarantia">
                <v-icon color="#F44336" x-large>mdi-check-box-outline</v-icon>
                <label class="text--s pl-1" style="font-family: Heebo; font-weight: normal">SI se permite reparaciones de este dispositivo DENTRO de garantía</label>
            </template>
            <template v-else>
                <v-icon color="#F44336" x-large>mdi-close-box-outline</v-icon>
                <label class="text--s pl-1" style="font-family: Heebo; font-weight: normal">NO se permite reparaciones de este dispositivo DENTRO de garantía</label>
            </template>
        </p>
        <p class="text--s">
            <template v-if="fueraDeGarantia">
                <v-icon color="#9be51a" x-large>mdi-check-box-outline</v-icon>
                <label class="text--s pl-1" style="font-family: Heebo; font-weight: normal">SI se permite reparaciones de este dispositivo FUERA de garantía</label>
            </template>
            <template v-else>
                <v-icon color="#F44336" x-large>mdi-close-box-outline</v-icon>
                <label class="text--s pl-1" style="font-family: Heebo; font-weight: normal">NO se permite reparaciones de este dispositivo FUERA de garantía</label>
            </template>
        </p>
    </div>
</template>

<script>
    export default {
        props: {
            catalogosReparacion: Array,
        },
        computed: {
            enGarantia() {
                if (this.catalogosReparacion.length > 0) {
                    if (this.catalogosReparacion.filter((s) => s.GARANTIA == true).length > 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            fueraDeGarantia() {
                if (this.catalogosReparacion.length > 0) {
                    if (this.catalogosReparacion.filter((s) => s.GARANTIA == false).length > 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            }
        }
    }
</script>